// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_ActiveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /lgpd_terms/active
 *
 * Returns the currently active LGPD term, or null if none is set.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LgpdTerms_ActiveResponseDados {
id: number
titulo: string
versao: string
conteudo: string
created_at: string
}

export type LgpdTerms_ActiveResponse = ApiResponse<LgpdTerms_ActiveResponseDados>;

registerResponseContract('LgpdTerms_ActiveResponse', {
  id:         { type: 'number',  required: false },
  titulo:     { type: 'string',  required: false },
  versao:     { type: 'string',  required: false },
  conteudo:   { type: 'string',  required: false },
  created_at: { type: 'string',  required: false },
})
